export default {_name:'Text.Chip',module:'Field',view:'Element/Text/Chip',options:{xs:12},mobileOptions:{ms:12}}